import { render, staticRenderFns } from "./projectConfig.vue?vue&type=template&id=7dd080bd&scoped=true"
import script from "./projectConfig.vue?vue&type=script&lang=js"
export * from "./projectConfig.vue?vue&type=script&lang=js"
import style0 from "./projectConfig.vue?vue&type=style&index=0&id=7dd080bd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd080bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd080bd')) {
      api.createRecord('7dd080bd', component.options)
    } else {
      api.reload('7dd080bd', component.options)
    }
    module.hot.accept("./projectConfig.vue?vue&type=template&id=7dd080bd&scoped=true", function () {
      api.rerender('7dd080bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/projectConfig.vue"
export default component.exports